import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '@gonka-wallet/storage';
import { detectInitialLocale, type ResolvedLocale } from './detect.js';
import en from './locales/en.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

export async function initI18n(
  explicit: Locale,
  tmaLanguageCode: string | undefined,
): Promise<void> {
  const locale = detectInitialLocale({
    explicit,
    tmaLanguageCode,
    browserLanguages:
      typeof navigator !== 'undefined' ? (navigator.languages ?? []) : [],
    singleLanguage:
      typeof navigator !== 'undefined' ? navigator.language : undefined,
  });

  await i18next.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      zh: { translation: zh },
    },
    lng: locale,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export async function changeLocale(locale: ResolvedLocale): Promise<void> {
  await i18next.changeLanguage(locale);
}
